import { IEmbedConfig } from './types'

interface IWindow extends Window {
    google: any
    googleImaVansAdapter: any
}

declare let window: IWindow

enum IAS_XPS {
    AUTOPLAY = 'autoplayed',
    CLICKTOPLAY = 'clicktoplay'
}

enum IAS_XBP {
    PREROLL = '1',
    MIDROLL = '2',
    POSTROLL = '3',
    STANDALONE = '4'
}

enum IAS_XAR {
    AUTOREFRESHON = '1',
    AUTOREFRESHOFF = '0'
}

export class BrandSafety {
    public static adSize = '640x480'

    public static checkValidPlayer(videoElement: HTMLElement): boolean {
        // player is an HTML element, is visible, and the page is not loading
        if (
            videoElement.nodeType === 1 &&
            videoElement.getBoundingClientRect().width > 0 &&
            videoElement.getBoundingClientRect().height > 0 &&
            window.document.readyState !== 'loading'
        ) {
            return true
        }
        return false
    }

    public static async onAdsManagerLoaded(
        event: any,
        embedConfig: IEmbedConfig
    ): Promise<void> {
        // googima.js script must be loaded to load IAS script
        if (!document.querySelector('script[src $= "googima.js"]')) return

        // video player must be visible
        if (!BrandSafety.checkValidPlayer(event.videoElement)) return

        const adsManager = event.adsManager
        const videoElement = event.videoElement
        const targetingDict = BrandSafety.parseTargeting(
            embedConfig.adsConfig?.adTagParameters.cust_params || ''
        )
        const page = targetingDict['page'] || ''
        const pr = targetingDict['pr'] || ''
        const config = {
            campId: BrandSafety.adSize,
            // for chanId use only alphanumeric characters with a maximum length of 50
            chanId: embedConfig.adsConfig?.adTagParameters.iu,
            pubOrder: 'Video Orders',
            pubId: '', // when non-AdX creatives
            custom: page,
            custom2: pr,
            ias_xps: IAS_XPS.CLICKTOPLAY,
            ias_xbp: IAS_XBP.PREROLL,
            ias_xar: IAS_XAR.AUTOREFRESHOFF
        }

        // Check if googleImaVansAdapter is available before calling init
        if (!window.googleImaVansAdapter || !window.googleImaVansAdapter.init) {
            return
        }

        window.googleImaVansAdapter.init(
            window.google,
            adsManager,
            videoElement,
            config
        )
    }

    public static parseTargeting(targeting: string) {
        const targetingItems = targeting.split('%26')
        const targetingDict: { [key: string]: string } = {}
        for (const item of targetingItems) {
            const split = item.split('%3D')
            targetingDict[split[0]] = split[1]
        }
        return targetingDict
    }
}
